<template>
  <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <div
          id="account"
          v-bind="attrs"
          v-on="on"
      >
        <span id="account-name" class="hidden-md-and-down">{{profile.name}}</span>
        <v-avatar color="secondary" class="mx-2" size="40">
          <v-icon>mdi-account-outline</v-icon>
        </v-avatar>
        <v-icon color="white" class="hidden-md-and-down">mdi-menu-down</v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="secondary" size="40">
            <v-icon>mdi-account-outline</v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{profile.name}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{profile.email}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>
      <v-list-item>
        <v-list-item-title>
          <v-btn text block class="text-none" color="primary" @click="signOut">Log out</v-btn>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {sync} from "vuex-pathify";
import {mapActions} from "vuex";

export default {
  name: "Account",
  computed: {
    profile: sync('user/profile')
  },
  methods: {
    ...mapActions('auth', ['signOut'])
  }
}
</script>

<style scoped lang="scss">
#account-name {
  font-size: 14px;
  color: white;
  font-weight: 700;
}

</style>
